/*
 * @Author: kuangxj 
 * @Email: frankxjkuang@gmail.com 
 * @Date: 2018-07-09 17:30:56 
 * @Last Modified by:   kaungxj 
 * @Last Modified time: 2018-07-09 17:30:56 
 * @Description: File desctiption 
 */

import MoorSelect from './moor-select';

MoorSelect.install = Vue => Vue.component(MoorSelect.name, MoorSelect);

export default MoorSelect;


// WEBPACK FOOTER //
// ./src/packages/select/index.js